import { render, staticRenderFns } from "./restore.vue?vue&type=template&id=7aa80b1f&"
import script from "./restore.vue?vue&type=script&lang=js&"
export * from "./restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports